/**
 * Constants relating to sessionStorage.
 */

/**
 * Key to store whether admin should be shown the feedback modal
 */
export const ADMIN_FEEDBACK_SESSION_KEY = 'admin-feedback-key'
